/* Native disclosure navigation; all buying remains in Shopify's existing product forms. */
(() => {
  'use strict';
  const selector = '[data-cm-shop-nav]';
  const close = (details, restoreFocus = false) => {
    details.open = false;
    const summary = details.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) summary?.focus();
  };
  const sync = (root = document) => {
    root.querySelectorAll(selector).forEach(details => {
      details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
    });
  };
  document.addEventListener('toggle', event => {
    if (event.target.matches?.(selector)) sync(event.target.parentElement);
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll(`${selector}[open]`).forEach(details => {
      if (!details.contains(event.target) || event.target.closest('a')) close(details);
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll(`${selector}[open]`).forEach(details => {
      if (!details.contains(event.target)) close(details);
    });
  });
  document.addEventListener('keydown', event => {
    const details = event.target.closest(selector);
    if (!details) return;
    if (event.key === 'Escape' && details.open) {
      event.preventDefault();
      close(details, true);
      return;
    }
    if (event.target === details.querySelector('summary') && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
      const links = [...details.querySelectorAll('a[href]')];
      if (!links.length) return;
      event.preventDefault();
      details.open = true;
      details.querySelector('summary').setAttribute('aria-expanded', 'true');
      (event.key === 'ArrowDown' ? links[0] : links[links.length - 1]).focus();
    }
  });
  document.addEventListener('shopify:section:load', event => sync(event.target));
  sync();
})();
